const NAME_TOKEN = 'TokenClientHub';
let getToken = () => {
  return localStorage.getItem(NAME_TOKEN);
}
let setToken = (token) => {
  return localStorage.setItem(NAME_TOKEN,token);
}
let isLoggedIn = () => {
  let token = getToken();

  if (token) {
    let payload = JSON.parse(atob(token.split('.')[1]));
    // let payload = JSON.parse(Buffer.from(token.split('.')[1], 'base64'));
    return (payload.exp)*1000 > Date.now();
  } else {
    return false;
  }
}
let existToken = () => {
  let token = getToken();
  if (token) {
    return true;
  } else {
    return false;
  }
}
let getUser =  () => {
  if (isLoggedIn()) {
    let token = getToken();
    let payload = JSON.parse(atob(token.split('.')[1]));
    // let payload = JSON.parse(Buffer.from(token.split('.')[1], 'base64'));
    let user = {
      rol: +payload.user.rol,
      idUsuario: payload.user.id,
      name: payload.user.name,
      username: payload.user.user
    }
    // let user = payload.user;
    return user;
  }
  return null;
}
let logout = () => {
  localStorage.removeItem(NAME_TOKEN);
}

export default {
  getToken,
  setToken,
  existToken,
  isLoggedIn,
  getUser,
  logout
}